<template>
<div class="installed-list-callback">
    <BasePage v-bind="config" :list="sortedList" v-on="listeners"></BasePage>
    <!-- 全量回传提示，居中显示 -->
    <div v-if="isAllCallbacked" class="full-callback-message">
        <div class="message-content">已全量回传安装列表</div>
    </div>
</div>
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash'
import exportUtils from '@/components/util/export-utils.js'

export default {
    components: {
        BasePage
    },
    data: function () {
        return {
            queryCondition:{
                'plaintextPackageName': "",
                'packageNameMappingId': "",
                'operatingSystem': "",
                'isEffective': "",
                'isPlaintextCallback': ""
            },
            list: [],
            isAllCallbacked: false, // 是否已全量回传
            hasNoPackages: false, // 是否无任何包名
            listeners: {
                input: this.onInput,
                action: this.doAction,
            },
            config:{
                searchConfigs: [
                    [
                    {name:'plaintextPackageName', label:'明文包名: ',ctx:'inputText', placeholder: '请输入明文包名,多个用,分隔', width: '320px'},
                    {name:'packageNameMappingId', label:'包名映射ID: ',ctx:'inputText', placeholder: '请输入包名映射ID,多个用,分隔', width: '320px'},
                    ],
                    [
                    {name:'isPlaintextCallback', label:'是否明文回传: ',ctx:'inputSelect',
                        options: [
                            {id: '是', name: '是'},
                            {id: '否', name: '否'},
                        ],
                        placeholder: '请选择',
                        width: '320px'
                    },
                    {name:'operatingSystem', label:'操作系统: ',ctx:'inputSelect',
                        options: [
                            {id: 'Android', name: 'Android'},
                            {id: 'iOS', name: 'iOS'},
                            {id: '鸿蒙', name: '鸿蒙'},
                        ],
                        placeholder: '请选择操作系统',
                        width: '320px'
                    },
                    {name:'isEffective', label:'是否生效: ',ctx:'inputSelect',
                        options: [
                            {id: '是', name: '是'},
                            {id: '否', name: '否'},
                        ],
                        placeholder: '请选择',
                        width: '320px'
                    }
                    ]
                ],
                tableConfigs: [
                    {prop:'number', label:'编号'},
                    {prop:'plaintextPackageName', label:'明文包名'},
                    {prop:'packageNameMappingId', label:'包名映射ID'},
                    {prop:'isPlaintextCallback', label:'是否明文回传'},
                    {prop:'operatingSystem', label:'操作系统'},
                    {prop:'isEffective', label:'是否生效'},
                    {prop:'createTime', label:'创建时间'},
                    {prop:'lastModifiedTime', label:'最近修改时间'},
                ],
                actions: [
                    { name: 'create', label: '编辑' }
                ],
                showAction: true
            },
        }
    },
    created: function() {
        this.loadData();
    },
    computed: {
        filterList: function () {
            // 如果已全量回传或无任何包名，返回空数组（会在sortedList中处理显示）
            if (this.isAllCallbacked || this.hasNoPackages) {
                return [];
            }

            let plaintextPackageName = this.queryCondition.plaintextPackageName || ""
            let packageNameMappingId = this.queryCondition.packageNameMappingId || ""
            let operatingSystem = this.queryCondition.operatingSystem || ""
            let isEffective = this.queryCondition.isEffective || ""
            let isPlaintextCallback = this.queryCondition.isPlaintextCallback || ""

            return _.filter(this.list, (it) => {
                // 明文包名模糊搜索，支持逗号分隔多个
                let packageNameMatch = true;
                if (plaintextPackageName) {
                    let packageNames = plaintextPackageName.split(',').map(s => s.trim()).filter(s => s);
                    if (packageNames.length > 0) {
                        packageNameMatch = packageNames.some(pkg => {
                            let pkgName = (it.plaintextPackageName || it.appPackage || '') + "";
                            return pkgName.includes(pkg);
                        });
                    }
                }

                // 包名映射ID模糊搜索，支持逗号分隔多个
                let mappingIdMatch = true;
                if (packageNameMappingId) {
                    let mappingIds = packageNameMappingId.split(',').map(s => s.trim()).filter(s => s);
                    if (mappingIds.length > 0) {
                        mappingIdMatch = mappingIds.some(id => {
                            let mappingId = (it.packageNameMappingId || it.appPackageId || '') + "";
                            return mappingId.includes(id);
                        });
                    }
                }

                // 操作系统匹配（支持数字值：33=Android, 32=iOS, 39=鸿蒙）
                let osMatch = true;
                if (operatingSystem) {
                    if (operatingSystem === 'Android') {
                        osMatch = it.operatingSystem === 'Android' || it.operatingSystem === '33' || it.operatingSystem === 33;
                    } else if (operatingSystem === 'iOS') {
                        osMatch = it.operatingSystem === 'iOS' || it.operatingSystem === '32' || it.operatingSystem === 32;
                    } else if (operatingSystem === '鸿蒙') {
                        osMatch = it.operatingSystem === '鸿蒙' || it.operatingSystem === '39' || it.operatingSystem === 39;
                    } else {
                        osMatch = it.operatingSystem === operatingSystem;
                    }
                }

                // 是否生效匹配
                let effectiveMatch = !isEffective || it.isEffective === isEffective;

                // 是否明文回传匹配
                let callbackMatch = !isPlaintextCallback || it.isPlaintextCallback === isPlaintextCallback;

                return packageNameMatch && mappingIdMatch && osMatch && effectiveMatch && callbackMatch;
            })
        },
        sortedList: function () {
            // 如果已全量回传，返回空数组（提示信息通过模板中的 v-if 显示）
            if (this.isAllCallbacked) {
                return [];
            }

            // 如果无任何包名，显示特殊提示
            if (this.hasNoPackages) {
                return [{
                    number: '',
                    plaintextPackageName: '无',
                    packageNameMappingId: '',
                    isPlaintextCallback: '',
                    operatingSystem: '',
                    isEffective: '',
                    createTime: '',
                    lastModifiedTime: ''
                }];
            }

            // 正常情况：排序并添加编号
            // 按照最近修改时间倒序排序；如果时间相同则按照序号倒序排序
            let sorted = _.orderBy(this.filterList, [
                function(item) { return item.lastModifiedTime || item.updateTime || ''; },
                function(item) { return item.id || 0; }
            ], ['desc', 'desc']);

            // 添加编号（从1开始）
            return sorted.map((item, index) => {
                return {
                    ...item,
                    number: index + 1
                };
            });
        }
    },
    methods: {
        loadData: function() {
            const accountId = this.$store.state.accountInfo?.id;
            if (!accountId) {
                this.$notify.error({ title: '错误', message: '无法获取账户信息' });
                return;
            }
            
            // 先检查是否为全量回传
            sspApi.isFullFeedback({
                params: {
                    accountId: accountId
                }
            }).then((response) => {
                window.console.log('isFullFeedback response:', response);
                
                // 判断返回结果：1表示全量回传，0表示正常
                let isFull = false;
                if (typeof response === 'number') {
                    isFull = response === 1;
                } else if (typeof response === 'string') {
                    isFull = response === '1' || response === 'true';
                } else if (typeof response === 'object') {
                    // 支持多种可能的字段名
                    isFull = response.isFullFeedback === 1 || 
                             response.isFullFeedback === '1' ||
                             response.isFull === 1 ||
                             response.isFull === '1' ||
                             response.fullFeedback === 1 ||
                             response.fullFeedback === '1' ||
                             response === true;
                }
                
                if (isFull) {
                    // 全量回传，设置状态并显示提示
                    this.isAllCallbacked = true;
                    this.hasNoPackages = false;
                    this.list = [];
                    window.console.log('Is full feedback, showing special message');
                    return;
                }
                
                // 不是全量回传，继续加载正常数据
                this.loadNormalData(accountId);
            }).catch((error) => {
                window.console.error('isFullFeedback API error:', error);
                // 如果检查全量回传的接口失败，继续加载正常数据
                this.loadNormalData(accountId);
            });
        },
        // 加载正常数据
        loadNormalData: function(accountId) {
            sspApi.listInstalledListCallback({
                params: {
                    accountId: accountId
                }
            }).then((response) => {
                window.console.log('API response:', response);
                
                // 如果返回的是数组，直接使用
                if (Array.isArray(response)) {
                    this.isAllCallbacked = false;
                    this.hasNoPackages = response.length === 0;
                    this.list = this.normalizeData(response);
                    window.console.log('Processed list (array):', this.list);
                    return;
                }
                
                // 检查是否已全量回传（兼容旧接口返回）
                if (response.isAllCallbacked) {
                    this.isAllCallbacked = true;
                    this.hasNoPackages = false;
                    this.list = [];
                } else if (response.hasNoPackages) {
                    this.isAllCallbacked = false;
                    this.hasNoPackages = true;
                    this.list = [];
                } else {
                    this.isAllCallbacked = false;
                    this.hasNoPackages = false;
                    // 支持多种数据结构：response.list 或 response.data 或直接是数组
                    let rawList = response.list || response.data || [];
                    this.list = this.normalizeData(rawList);
                }
                
                window.console.log('Processed list:', this.list);
                window.console.log('isAllCallbacked:', this.isAllCallbacked);
                window.console.log('hasNoPackages:', this.hasNoPackages);
            }).catch((error) => {
                window.console.error('API error:', error);
                this.$rejectAjaxError()(error);
            });
        },
        onInput: function (val) {
            _.assign(this.queryCondition, val);
        },
        doAction: function (name) {
            if (name === 'create') {
                this.$router.push({name: 'packageNameBatchEdit'})
            }
            if (name === 'export') {
                this.doExport()
            }
        },
        doExport: function () {
            // 如果已全量回传或无任何包名，导出空数据或提示
            if (this.isAllCallbacked || this.hasNoPackages) {
                this.$notify.info({ title: '提示', message: '当前无数据可导出' });
                return;
            }
            // 导出当前筛选后的全量数据，使用 sortedList 确保包含编号
            // 为 filterList 添加编号
            let exportList = this.filterList.map((item, index) => {
                return {
                    ...item,
                    number: index + 1
                };
            });
            exportUtils.export(exportList, this.config.tableConfigs)
        },
        // 标准化数据字段名，确保字段名与表格配置一致
        normalizeData: function(dataList) {
            if (!Array.isArray(dataList)) {
                return [];
            }
            return dataList.map(item => {
                // 字段映射：
                // appPackage -> plaintextPackageName
                // appPackageId -> packageNameMappingId
                // updateTime -> lastModifiedTime
                // 操作系统标准化：确保显示为 Android、iOS 或鸿蒙
                // Android=33, iOS=32, 鸿蒙=39
                let osValue = item.operatingSystem || item.os || '';
                // 标准化操作系统值：统一转换为 Android、iOS 或鸿蒙
                if (osValue !== null && osValue !== undefined && osValue !== '') {
                    osValue = String(osValue).trim();
                    // 处理数字映射：33 -> Android, 32 -> iOS, 39 -> 鸿蒙
                    if (osValue === '33' || osValue === 33) {
                        osValue = 'Android';
                    } else if (osValue === '32' || osValue === 32) {
                        osValue = 'iOS';
                    } else if (osValue === '39' || osValue === 39) {
                        osValue = '鸿蒙';
                    } else if (osValue.toLowerCase() === 'android' || osValue.toLowerCase() === 'and') {
                        osValue = 'Android';
                    } else if (osValue.toLowerCase() === 'ios' || osValue.toLowerCase() === 'iphone') {
                        osValue = 'iOS';
                    } else if (osValue === 'harmonyos' || osValue === 'harmony') {
                        osValue = '鸿蒙';
                    }
                } else {
                    osValue = '';
                }
                
                // 包名映射ID
                let mappingId = item.appPackageId || item.packageNameMappingId || '';
                
                // 如果appPackageId字段为null或者空，则认为是明文回传
                let isPlaintextCallback = '否';
                if (!mappingId || mappingId === null || mappingId === '' || String(mappingId).trim() === '') {
                    isPlaintextCallback = '是';
                }
                
                // 处理是否生效：优先检查 valid 字段，然后检查 isEffective 和 effective 字段
                let isEffective = '是';
                // 优先处理 valid 字段（接口返回的字段）
                if (item.valid !== undefined && item.valid !== null) {
                    if (typeof item.valid === 'boolean') {
                        isEffective = item.valid ? '是' : '否';
                    } else if (typeof item.valid === 'string') {
                        isEffective = (item.valid === 'true' || item.valid === '1' || item.valid === '是') ? '是' : '否';
                    } else if (typeof item.valid === 'number') {
                        isEffective = item.valid === 1 ? '是' : '否';
                    }
                } else if (item.isEffective !== undefined && item.isEffective !== null) {
                    if (typeof item.isEffective === 'boolean') {
                        isEffective = item.isEffective ? '是' : '否';
                    } else if (typeof item.isEffective === 'string') {
                        isEffective = item.isEffective;
                    } else if (typeof item.isEffective === 'number') {
                        isEffective = item.isEffective === 1 ? '是' : '否';
                    }
                } else if (item.effective !== undefined && item.effective !== null) {
                    if (typeof item.effective === 'boolean') {
                        isEffective = item.effective ? '是' : '否';
                    } else if (typeof item.effective === 'string') {
                        isEffective = item.effective;
                    } else if (typeof item.effective === 'number') {
                        isEffective = item.effective === 1 ? '是' : '否';
                    }
                }
                
                return {
                    id: item.id,
                    plaintextPackageName: item.appPackage || item.plaintextPackageName || '',
                    packageNameMappingId: mappingId,
                    isPlaintextCallback: isPlaintextCallback,
                    operatingSystem: osValue,
                    isEffective: isEffective,
                    createTime: item.createTime || item.create_time || item.createdAt || '',
                    lastModifiedTime: item.updateTime || item.lastModifiedTime || item.last_modified_time || item.updatedAt || item.modifyTime || ''
                };
            });
        },
    }
}
</script>

<style scoped>
.installed-list-callback {
    position: relative;
}

.full-callback-message {
    position: absolute;
    top: 250px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: none;
}

.message-content {
    font-size: 16px;
    color: #606266;
    padding: 15px 30px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
    text-align: center;
    white-space: nowrap;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>

